import styled from "styled-components";

export const SelectField = styled.select`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid ${props => props.theme.colors.border};
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  font-size: 1rem;
  margin-top: 0.25rem;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.primary};
  }
`;

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  input[type="checkbox"] {
    width: 1rem;
    height: 1rem;
    cursor: pointer;
    accent-color: ${props => props.theme.colors.primary};
  }

  label {
    color: ${props => props.theme.colors.text};
    font-size: 0.9rem;
    cursor: pointer;
  }
`;
